import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";

import { getHelpArticlePath } from "@/common/utils/help/help-url.utils";
import { HelpArticleListItem } from "@/features/help/api";
import { HELP_RELATED_LIMIT } from "@/features/help/help.static";
import { Heading } from "@/ui/cva/Heading";
import { Body } from "@/ui/typography/Body";

type HelpRelatedProps = {
  articles: HelpArticleListItem[];
};

export const HelpRelated = ({ articles }: HelpRelatedProps) => {
  const { t } = useTranslation("common");
  const items = articles.slice(0, HELP_RELATED_LIMIT);

  if (!items.length) {
    return null;
  }

  return (
    <section className="mt-10">
      <Heading as="h2" size="h4">
        {t("help-related-title", "Related questions")}
      </Heading>
      <ul className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        {items.map(article => {
          if (!article.categorySlug) {
            return null;
          }

          return (
            <li key={article.id}>
              <Link
                href={getHelpArticlePath(article.categorySlug, article.slug)}
                className="block rounded-[10px] border border-grey-300 bg-white p-4 hover:border-grey-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-curious-200"
              >
                <Heading as="h3" size="h5">
                  {article.title}
                </Heading>
                {article.excerpt ? (
                  <Body as="p" className="mt-1 line-clamp-2 text-grey-800">
                    {article.excerpt}
                  </Body>
                ) : null}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
